module.exports = __webpack_public_path__ + "static/media/Rectangle Copy 57.4101aa87.png";